export default "__VITE_ASSET__BS$F_I8x__"